














import { Component, Prop, Vue } from 'vue-property-decorator';

import chat from '@/assets/icons/portal/chat.svg';
import check from '@/assets/icons/portal/check.svg';
import chevron from '@/assets/icons/portal/chevron.svg';
import close from '@/assets/icons/portal/close.svg';
import facebook from '@/assets/icons/portal/facebook.svg';
import instagram from '@/assets/icons/portal/instagram.svg';
import language from '@/assets/icons/portal/language.svg';
import play from '@/assets/icons/portal/play.svg';
import twitter from '@/assets/icons/portal/twitter.svg';
import vk from '@/assets/icons/portal/vk.svg';
import xsolla from '@/assets/icons/portal/xsolla.svg';

type SymbolsDict = {
  [key: string]: string | undefined;
};

const ICON_SYMBOLS: SymbolsDict = {
  chat: chat.id,
  check: check.id,
  chevron: chevron.id,
  close: close.id,
  facebook: facebook.id,
  instagram: instagram.id,
  language: language.id,
  play: play.id,
  twitter: twitter.id,
  vk: vk.id,
  xsolla: xsolla.id,
};

@Component
export default class PortalIcon extends Vue {
  @Prop({ type: String, required: true })
  readonly icon!: string;

  @Prop({ type: [String, Number], default: 18 })
  readonly size!: number | string;

  @Prop({ type: String, default: 'currentColor' })
  readonly color!: string;

  get symbolId() {
    return ICON_SYMBOLS[this.icon];
  }
}
